import React from 'react';
import Phonebook from './components/phonebook';

function App() {
  return <Phonebook />;
}

export default App;
